import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import { OrderDonorCoveredFeesValue } from './order-donor-covered-fees-types'
import orderDonorCoveredFeesSlice from './order-donor-covered-fees-slice'

const useOrderDonorCoveredFees = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const stateValue = useSelector((state: RootState) => state.order.dcf.value)

  return useMemo(
    () => ({
      value: stateValue,
      setValue: (value: Partial<OrderDonorCoveredFeesValue>) => {
        const newValue = { ...stateValue, ...value }
        dispatch(orderDonorCoveredFeesSlice.actions.setValue(newValue))
      },
    }),
    [dispatch, stateValue],
  )
}

export default useOrderDonorCoveredFees
